import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LivePackageEntity } from '../../domain/entities/LivePackageEntity'
import type { PackageStreamingAdminDto } from '@/backend/market'
export class LivePackageModel extends LivePackageEntity {
  constructor(dataDto: PackageStreamingAdminDto) {
    super()
    mapEntityProperties<LivePackageEntity>(this, dataDto,{
      map:{
        userId: dataDto.user?.id,
        userDisplayName: dataDto.user?.displayName,
        userPhoneNumber: dataDto.user?.phoneNumber,
        vehicleTemplateType: dataDto.vehicleTemplateType,
      }
    })
  }
}
